import React, { useState } from "react";
import {
  MostPopularCoursesNavbar,
  BackHeader,
  SideMenu,
  Model,
} from "./../../components";
import ProfileHeaderImage from "./../../../assets/images/profileHeader.png";
import ProfileImage from "./../../../assets/images/profileImage.jpg";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { MdEmail, MdWifiCalling3 } from "react-icons/md";
import EducationIcon from "./../../../assets/svg/educationIcon.svg";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { GrFacebookOption, GrTwitter } from "react-icons/gr";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useAlert } from "react-alert";
import Countries from "./../../../data/countries";
const MostPopularTutorsDetails = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [moreData, setMoreData] = useState(false);
  const location = useLocation();
  const [registerForm, setRegisterForm] = React.useState(false);
  const [countryCode, setCountryCode] = React.useState("");
  const [selectedCountryCode, setSelectedCountryCode] = React.useState();
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
    Countries.map((v, i) => {
      if (Countries[i].alpha2Code === e.target.value) {
        setSelectedCountryCode(Countries[i].callingCode);
      }
    });
  };

  // Register Form
  const [registerFirstName, setRegisterFirstName] = React.useState("");
  const [registerLastName, setRegisterLastName] = React.useState("");
  const [registerEmail, setRegisterEmail] = React.useState("");
  const [registerMobileNumber, setRegisterMobileNumber] = React.useState("");
  const [registerLoading, setRegisterLoading] = React.useState(false);
  const registerFirstNameRef = React.useRef();
  const registerLastNameRef = React.useRef();
  const registerEmailRef = React.useRef();
  const registerCountryCodeRef = React.useRef();
  const registerMobileNumberRef = React.useRef();
  const RegisterFormHandler = () => {
    if (registerFirstName === "") {
      alert.error(<div className="alert-message">first name required</div>);
      registerFirstNameRef.current.focus();
    } else if (registerLastName === "") {
      alert.error(<div className="alert-message">last name required</div>);
      registerLastNameRef.current.focus();
    } else if (registerEmail === "") {
      alert.error(
        <div className="alert-message">please enter email address</div>
      );
      registerEmailRef.current.focus();
    } else if (countryCode === "") {
      alert.error(
        <div className="alert-message">please select country code</div>
      );
      registerCountryCodeRef.current.focus();
    } else if (registerMobileNumber === "") {
      alert.error(
        <div className="alert-message">please enter valid mobile number</div>
      );
      registerMobileNumberRef.current.focus();
    } else {
      setRegisterLoading(true);
      const RegisterObject = {
        firstName: registerFirstName,
        lastName: registerLastName,
        email: registerEmail,
        countryCode: selectedCountryCode,
        mobileNumber: registerMobileNumber,
      };
      alert.success(
        <div className="alert-message">
          you have successfully register the tutors
        </div>
      );
      console.log(RegisterObject);
      setTimeout(() => {
        setRegisterForm(false);
        setRegisterLoading(false);
      }, 2000);
    }
  };
  return (
    <div>
      {location.state.type === "unauthorized" ? (
        <div>
          <MostPopularCoursesNavbar />
          <div style={{ margin: "20px 20px" }}>
            <BackHeader backHanler={() => navigate(-1)} />
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
                  <Button className="header-button" variant="text">
                    <p className="page-header-button-text">Download</p>
                  </Button>
                </Grid>

                <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                  <Button
                    className="header-button"
                    variant="text"
                    onClick={() => setRegisterForm(true)}
                  >
                    <p className="page-header-button-text">Register Now</p>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </div>

          <div>
            <img src={ProfileHeaderImage} className="header-cover-image" />
          </div>
          <div className="profile-image-main">
            <img src={ProfileImage} className="profile-image" />
          </div>
          <div className="user-personal-data-main">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                  <p className="user-name">David Anderson</p>
                  <p className="user-subjects-list">
                    English,mathematics, and science teachers
                  </p>
                  <p className="user-location">burnside, united state</p>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                  <p className="contact-information-heading">
                    Contact Information
                  </p>
                  <div className="contact-information-list">
                    <MdEmail color="#303030" size={20} />
                    <p className="contact-information-list-title">
                      Support@amafclasses.com
                    </p>
                  </div>
                  <div className="contact-information-list">
                    <MdWifiCalling3 color="#303030" size={20} />
                    <p className="contact-information-list-title">
                      +971 1 2345678
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Box>
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date"></p>
              </div>
              <div className="share-main">
                <p className="data-view-cover-footer-data">share</p>
                <div>
                  <button className="share-button">
                    <GrFacebookOption color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaLinkedinIn color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <GrTwitter color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaWhatsapp color="white" size={20} />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Overview</p>
            </div>
            <p className="everview-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
              lorem congue, euismod urna vitae, porttitor mi. Aliquam
              consectetur eu turpis ac congue. Curabitur viverra nunc cursus est
              efficitur, sit amet ornare felis accumsan. Ut eget elementum sem.
              Sed et nibh pharetra, commodo neque at, porta odio. Lorem ipsum
              dolor sit amet.
            </p>
            {moreData && (
              <p className="everview-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue. Curabitur viverra nunc cursus
                est efficitur, sit amet ornare felis accumsan. Ut eget elementum
                sem. Sed et nibh pharetra, commodo neque at, porta odio. Lorem
                ipsum dolor sit amet. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. In in lorem congue, euismod urna vitae,
                porttitor mi. Aliquam consectetur eu turpis ac congue. Curabitur
                viverra nunc cursus est efficitur, sit amet ornare felis
                accumsan. Ut eget elementum sem. Sed et nibh pharetra, commodo
                neque at, porta odio. Lorem ipsum dolor sit amet.
              </p>
            )}
            <br />
            {!moreData && (
              <Button
                className="view-details-button"
                variant="text"
                onClick={() => setMoreData(true)}
              >
                See all details
              </Button>
            )}
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">established in which year</p>
            </div>
            <div className="box-data-main">
              <div className="box-list-main">
                <img src={ProfileImage} className="box-list-image" />
                <div>
                  <p className="box-list-heading">Gmits classes</p>
                  <p className="box-list-title">Institute</p>
                  <p className="box-list-date">jan 2018 - present 4 years</p>
                  <p className="box-list-location">
                    3501 California St, burnside, united state
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Certificate</p>
            </div>
            <div className="box-data-main">
              <div className="box-list-main">
                <div className="box-list-image">
                  <img src={EducationIcon} />
                </div>
                <div>
                  <p className="box-list-heading">Dubai University</p>
                  <p className="box-list-title">
                    Bachelor's degree, Information Technology
                  </p>
                  <p className="box-list-date">2013 - 2017</p>
                </div>
              </div>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Skills</p>
            </div>
            <div className="skills-main">
              <p className="skilles-title">English</p>
            </div>
            <div className="skills-main">
              <p className="skilles-title">Mathematics</p>
            </div>
            <div className="skills-main">
              <p className="skilles-title">Science</p>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Branches</p>
            </div>
            <div className="branches-list-main">
              <div className="box-list-main">
                <img src={ProfileImage} className="box-list-image" />
                <div>
                  <p className="box-list-heading">Dubai Branch</p>
                  <p className="branches-list-address">
                    3501 California St, burnside, united state
                  </p>
                  <p className="branches-list-description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                    in lorem congue, euismod urna vitae, porttitor mi. Aliquam
                    consectetur eu turpis ac congue.
                  </p>
                </div>
              </div>
            </div>
            <div className="branches-list-main">
              <div className="box-list-main">
                <img src={ProfileImage} className="box-list-image" />
                <div>
                  <p className="box-list-heading">Dubai Branch</p>
                  <p className="branches-list-address">
                    3501 California St, burnside, united state
                  </p>
                  <p className="branches-list-description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                    in lorem congue, euismod urna vitae, porttitor mi. Aliquam
                    consectetur eu turpis ac congue.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Recommendations</p>
            </div>
            <div className="box-rating-main">
              <div className="box-rating-header">
                <img src={ProfileImage} className="box-list-image" />

                <div className="box-rating-second-section">
                  <div>
                    <p className="box-rating-username">Johan smith</p>
                    <p className="box-rating-time">5 Lectures, 45 min</p>
                  </div>
                  <div className="box-rating-show">
                    <Stack spacing={1}>
                      <Rating
                        name="half-rating-read"
                        defaultValue={5}
                        precision={1}
                        readOnly
                      />
                    </Stack>
                    <p className="box-rating-day">Yesterday</p>
                  </div>
                </div>
              </div>
              <p className="box-rating-message">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue.
              </p>
            </div>
            <div className="box-rating-main">
              <div className="box-rating-header">
                <img src={ProfileImage} className="box-list-image" />

                <div className="box-rating-second-section">
                  <div>
                    <p className="box-rating-username">Johan smith</p>
                    <p className="box-rating-time">5 Lectures, 45 min</p>
                  </div>
                  <div className="box-rating-show">
                    <Stack spacing={1}>
                      <Rating
                        name="half-rating-read"
                        defaultValue={5}
                        precision={1}
                        readOnly
                      />
                    </Stack>
                    <p className="box-rating-day">Yesterday</p>
                  </div>
                </div>
              </div>
              <p className="box-rating-message">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <SideMenu>
          <div style={{ margin: "20px 20px" }}>
            <BackHeader backHanler={() => navigate(-1)} />
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
                <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
                  <Button className="header-button" variant="text">
                    <p className="page-header-button-text">Download</p>
                  </Button>
                </Grid>

                <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                  <Button
                    className="header-button"
                    variant="text"
                    onClick={() => setRegisterForm(true)}
                  >
                    <p className="page-header-button-text">Register Now</p>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </div>
          <div>
            <img src={ProfileHeaderImage} className="header-cover-image" />
          </div>
          <div className="profile-image-main">
            <img src={ProfileImage} className="profile-image" />
          </div>
          <div className="user-personal-data-main">
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                  <p className="user-name">David Anderson</p>
                  <p className="user-subjects-list">
                    English,mathematics, and science teachers
                  </p>
                  <p className="user-location">burnside, united state</p>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                  <p className="contact-information-heading">
                    Contact Information
                  </p>
                  <div className="contact-information-list">
                    <MdEmail color="#303030" size={20} />
                    <p className="contact-information-list-title">
                      Support@amafclasses.com
                    </p>
                  </div>
                  <div className="contact-information-list">
                    <MdWifiCalling3 color="#303030" size={20} />
                    <p className="contact-information-list-title">
                      +971 1 2345678
                    </p>
                  </div>
                </Grid>
              </Grid>
            </Box>
            <div className="data-view-cover-footer-container">
              <div className="data-view-cover-footer">
                <p className="data-view-cover-footer-date"></p>
              </div>
              <div className="share-main">
                <p className="data-view-cover-footer-data">share</p>
                <div>
                  <button className="share-button">
                    <GrFacebookOption color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaLinkedinIn color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <GrTwitter color="white" size={20} />
                  </button>
                  <button className="share-button">
                    <FaWhatsapp color="white" size={20} />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Overview</p>
            </div>
            <p className="everview-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
              lorem congue, euismod urna vitae, porttitor mi. Aliquam
              consectetur eu turpis ac congue. Curabitur viverra nunc cursus est
              efficitur, sit amet ornare felis accumsan. Ut eget elementum sem.
              Sed et nibh pharetra, commodo neque at, porta odio. Lorem ipsum
              dolor sit amet.
            </p>
            {moreData && (
              <p className="everview-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue. Curabitur viverra nunc cursus
                est efficitur, sit amet ornare felis accumsan. Ut eget elementum
                sem. Sed et nibh pharetra, commodo neque at, porta odio. Lorem
                ipsum dolor sit amet. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. In in lorem congue, euismod urna vitae,
                porttitor mi. Aliquam consectetur eu turpis ac congue. Curabitur
                viverra nunc cursus est efficitur, sit amet ornare felis
                accumsan. Ut eget elementum sem. Sed et nibh pharetra, commodo
                neque at, porta odio. Lorem ipsum dolor sit amet.
              </p>
            )}
            <br />
            {!moreData && (
              <Button
                className="view-details-button"
                variant="text"
                onClick={() => setMoreData(true)}
              >
                See all details
              </Button>
            )}
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">established in which year</p>
            </div>
            <div className="box-data-main">
              <div className="box-list-main">
                <img src={ProfileImage} className="box-list-image" />
                <div>
                  <p className="box-list-heading">Gmits classes</p>
                  <p className="box-list-title">Institute</p>
                  <p className="box-list-date">jan 2018 - present 4 years</p>
                  <p className="box-list-location">
                    3501 California St, burnside, united state
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Certificate</p>
            </div>
            <div className="box-data-main">
              <div className="box-list-main">
                <div className="box-list-image">
                  <img src={EducationIcon} />
                </div>
                <div>
                  <p className="box-list-heading">Dubai University</p>
                  <p className="box-list-title">
                    Bachelor's degree, Information Technology
                  </p>
                  <p className="box-list-date">2013 - 2017</p>
                </div>
              </div>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Skills</p>
            </div>
            <div className="skills-main">
              <p className="skilles-title">English</p>
            </div>
            <div className="skills-main">
              <p className="skilles-title">Mathematics</p>
            </div>
            <div className="skills-main">
              <p className="skilles-title">Science</p>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Branches</p>
            </div>
            <div className="branches-list-main">
              <div className="box-list-main">
                <img src={ProfileImage} className="box-list-image" />
                <div>
                  <p className="box-list-heading">Dubai Branch</p>
                  <p className="branches-list-address">
                    3501 California St, burnside, united state
                  </p>
                  <p className="branches-list-description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                    in lorem congue, euismod urna vitae, porttitor mi. Aliquam
                    consectetur eu turpis ac congue.
                  </p>
                </div>
              </div>
            </div>
            <div className="branches-list-main">
              <div className="box-list-main">
                <img src={ProfileImage} className="box-list-image" />
                <div>
                  <p className="box-list-heading">Dubai Branch</p>
                  <p className="branches-list-address">
                    3501 California St, burnside, united state
                  </p>
                  <p className="branches-list-description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                    in lorem congue, euismod urna vitae, porttitor mi. Aliquam
                    consectetur eu turpis ac congue.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="data-box">
            <div className="data-box-header">
              <p className="data-box-heading">Recommendations</p>
            </div>
            <div className="box-rating-main">
              <div className="box-rating-header">
                <img src={ProfileImage} className="box-list-image" />

                <div className="box-rating-second-section">
                  <div>
                    <p className="box-rating-username">Johan smith</p>
                    <p className="box-rating-time">5 Lectures, 45 min</p>
                  </div>
                  <div className="box-rating-show">
                    <Stack spacing={1}>
                      <Rating
                        name="half-rating-read"
                        defaultValue={5}
                        precision={1}
                        readOnly
                      />
                    </Stack>
                    <p className="box-rating-day">Yesterday</p>
                  </div>
                </div>
              </div>
              <p className="box-rating-message">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue.
              </p>
            </div>
            <div className="box-rating-main">
              <div className="box-rating-header">
                <img src={ProfileImage} className="box-list-image" />

                <div className="box-rating-second-section">
                  <div>
                    <p className="box-rating-username">Johan smith</p>
                    <p className="box-rating-time">5 Lectures, 45 min</p>
                  </div>
                  <div className="box-rating-show">
                    <Stack spacing={1}>
                      <Rating
                        name="half-rating-read"
                        defaultValue={5}
                        precision={1}
                        readOnly
                      />
                    </Stack>
                    <p className="box-rating-day">Yesterday</p>
                  </div>
                </div>
              </div>
              <p className="box-rating-message">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue.
              </p>
            </div>
          </div>
        </SideMenu>
      )}

      <Model
        modelTitle="Register Now"
        onClose={() => setRegisterForm(false)}
        open={registerForm}
        buttonTitle="Register"
        buttonHandler={RegisterFormHandler}
        loading={registerLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">First name</p>
                  <input
                    type="text"
                    name="firstName"
                    className="input"
                    placeholder="Name"
                    value={registerFirstName}
                    ref={registerFirstNameRef}
                    onChange={(e) => setRegisterFirstName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Last name</p>
                  <input
                    type="text"
                    name="lastName"
                    className="input"
                    placeholder="Name"
                    value={registerLastName}
                    ref={registerLastNameRef}
                    onChange={(e) => setRegisterLastName(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Email Address</p>
                  <input
                    type="email"
                    name="email"
                    required="required"
                    className="input"
                    placeholder="Email Address"
                    value={registerEmail}
                    ref={registerEmailRef}
                    onChange={(e) => setRegisterEmail(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Mobile Number</p>
                  <div className="country-code-picker-main">
                    <div className="country-code-picker-dropdown-main">
                      <select
                        className="country-code-picker-dropdown"
                        ref={registerCountryCodeRef}
                        onChange={handleDropdownChange}
                      >
                        <option value="">Select</option>
                        {Countries.map((countriesValue, countriesIndex) => {
                          return (
                            <option
                              key={countriesIndex}
                              value={countriesValue.alpha2Code}
                            >
                              {`${countriesValue.callingCode}  ${countriesValue.name}`}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="country-flag-main">
                      {Countries.map(
                        (countriesFlagValue, countriesFlagIndex) => {
                          return (
                            <div key={countriesFlagIndex}>
                              {countriesFlagValue.alpha2Code ===
                                countryCode && (
                                <img
                                  src={countriesFlagValue.flag}
                                  className="country-flag"
                                />
                              )}
                            </div>
                          );
                        }
                      )}
                      <input
                        type="number"
                        name="mobileNumber"
                        className="mobile-number-input"
                        placeholder="Enter your mobile number"
                        value={registerMobileNumber}
                        ref={registerMobileNumberRef}
                        onChange={(e) =>
                          setRegisterMobileNumber(e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </div>
  );
};
export default MostPopularTutorsDetails;
